export default __webpack_public_path__ + "static/media/arrow-down.55ce9717.svg";